"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DentalMonitoringMonitoring_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var DentalMonitoringMonitoring_Factory = /** @class */ (function () {
    function DentalMonitoringMonitoring_Factory() {
    }
    DentalMonitoringMonitoring_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            due_date: model.due_date,
            DueDate: Date_Factory_1.Date_Factory.CreateIncoming(model.DueDate),
            pause_date: model.pause_date,
            PauseDate: Date_Factory_1.Date_Factory.CreateIncoming(model.PauseDate),
            resume_date: model.resume_date,
            ResumeDate: Date_Factory_1.Date_Factory.CreateIncoming(model.ResumeDate),
            start_date: model.start_date,
            StartDate: Date_Factory_1.Date_Factory.CreateIncoming(model.StartDate),
            status: model.status,
            stop_date: model.stop_date,
            StopDate: Date_Factory_1.Date_Factory.CreateIncoming(model.StopDate),
        };
        return result;
    };
    DentalMonitoringMonitoring_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            due_date: model.due_date,
            DueDate: Date_Factory_1.Date_Factory.CreateOutgoing(model.DueDate),
            pause_date: model.pause_date,
            PauseDate: Date_Factory_1.Date_Factory.CreateOutgoing(model.PauseDate),
            resume_date: model.resume_date,
            ResumeDate: Date_Factory_1.Date_Factory.CreateOutgoing(model.ResumeDate),
            start_date: model.start_date,
            StartDate: Date_Factory_1.Date_Factory.CreateOutgoing(model.StartDate),
            status: model.status,
            stop_date: model.stop_date,
            StopDate: Date_Factory_1.Date_Factory.CreateOutgoing(model.StopDate),
        };
        return result;
    };
    return DentalMonitoringMonitoring_Factory;
}());
exports.DentalMonitoringMonitoring_Factory = DentalMonitoringMonitoring_Factory;
